// CSS Modules - component class name: Select__

<template>
  <div
    :class="[
      { Select__blue: colour === 'blue' },
      { Select__white: colour === 'white' },
      { Select__filter: colour === 'filter' },
      $style.select
    ]"
  >
    <multiselect
      v-if="isMulti"
      v-model="multiValue"
      :options="options"
      :searchable="false"
      :show-labels="false"
      :trackBy="trackBy"
      :label="label"
      :placeholder="placeholder"
      :allow-empty="true"
      :index="index"
      :multiple="true"
    ></multiselect>
    <multiselect
      v-else
      v-model="value"
      :options="options"
      :searchable="false"
      :show-labels="false"
      :trackBy="trackBy"
      :label="label"
      :placeholder="placeholder"
      :allow-empty="false"
      :index="index"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "Select",
  components: { Multiselect },
  props: {
    colour: {
      type: String,
      default: "blue"
    },
    selectValue: {
      type: String,
      default: ""
    },
    selectMultiValue: {
      type: [String, Array],
      default: () => []
    },
    selectOptions: {
      type: Array,
      default() {
        return [""];
      }
    },
    selectIndex: {
      type: String,
      default: ""
    },
    trackBy: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    isMulti: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    },
    category: {
      type: String,
      default: undefined
    },
    activeSelect: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      value: this.selectValue,
      multiValue: this.selectMultiValue,
      options: this.selectOptions,
      index: this.selectIndex
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("onChange", newValue);
      }
    },
    multiValue: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue.length === 0) {
          this.multiValue.push(this.options[0]);
        } else if (newValue.length > 1) {
          if (newValue[0] === this.options[0]) {
            this.multiValue.shift();
          } else if (newValue.includes(this.options[0])) {
            this.multiValue = [this.options[0]];
          }
        }
        this.$emit("multiChanged", this.multiValue);
      }
    },
    selectOptions: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (
          this.multiValue[0] === this.selectOptions[0] ||
          this.activeSelect !== this.category
        ) {
          this.options = this.selectOptions;
        }
      }
    },
    reset: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.multiValue = [];
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style module lang="scss">
@import "./Select.scss";
</style>
